import { type Maybe } from "@oefr/utils/types"

type EligibilityErrors = Array<{
    code: string
    message: string
    details: string
}>

function hasEPRM16Error(errors: EligibilityErrors) {
    return errors.some((error) => error.code === "EPRM016")
}

export function getShouldBeMesFromEligibilityErrors(errors: Maybe<EligibilityErrors>) {
    return !!errors && hasEPRM16Error(errors)
}
